import React from 'react';
import { useReveal } from './useReveal';
type RevealVariant = 'up' | 'left' | 'scale';
interface RevealProps {
  children: React.ReactNode;
  as?: 'div' | 'article' | 'section' | 'p';
  variant?: RevealVariant;
  delay?: number;
  className?: string;
}
const variantClass: Record<RevealVariant, string> = {
  up: '',
  left: 'reveal-left',
  scale: 'reveal-scale'
};
export function Reveal({
  children,
  as: Tag = 'div',
  variant = 'up',
  delay = 0,
  className = ''
}: RevealProps) {
  const ref = useReveal<HTMLDivElement>();
  return <Tag ref={ref} style={delay ? {
    transitionDelay: `${delay}ms`
  } : undefined} className={`reveal ${variantClass[variant]} ${className}`.trim()} data-id="element-202" data-mp="2nsjudane3d5x">
      {children}
    </Tag>;
}